export default __webpack_public_path__ + "static/media/5.6ba5629d.svg";